<template>
  <div>
    <empty-box class="query-form">
      <a-form-model :model="searchForm" layout="inline" ref="searchForm">
        <a-form-model-item label="订单编号" prop="orderId">
          <a-input v-model="searchForm.orderId" placeholder="请输入订单编号" allowClear />
        </a-form-model-item>
        <a-form-model-item label="申请发票状态" prop="invoiceStatus">
          <a-select v-model="searchForm.invoiceStatus" placeholder="请选择" class="w140" @change="handleQuery">
            <a-select-option value="0">不可申请</a-select-option>
            <a-select-option value="1">可申请</a-select-option>
            <a-select-option value="2">申请中</a-select-option>
            <a-select-option value="3">可下载</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="handleQuery">查询</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="resetForm">重置</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="$router.push({name:'invoiceInfo'})">新增发票</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="handleInvoice">去开票</a-button>
        </a-form-model-item>
      </a-form-model>
    </empty-box>

    <a-table :columns="columns" :data-source="list" bordered :pagination="false" class="table-list">
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
      <template slot="status" slot-scope="text">
        <a-tag :color="statusList[text].color">{{ statusList[text].text }}</a-tag>
      </template>
      <span slot="invoiceAmount" slot-scope="text">{{ text/100 }}</span>
      <span slot="action" slot-scope="record">
        <a-button type="link" @click="handleDetail(record)">详情</a-button>
        <a-button type="link" @click="handleDownload(record)" v-if="record.status == 3">下载</a-button>
      </span>
    </a-table>

    <a-modal
      v-model="visible"
      title="发票详情"
      width="1000px"
      :footer="null">
      <div>
        <h3 class="subtitle">发票基本信息</h3>
        <a-form layout="horizontal" class="info" :label-col=" { span: 2 }" :wrapper-col="{ span: 20 }">
          <a-form-item label="发票状态">
            <a-tag color="orange" v-if="detail.status == 2">审核中</a-tag>
            <a-tag color="green" v-if="detail.status == 3">已开票</a-tag>
          </a-form-item>
          <a-form-item label="发票类型">
            <span>{{ detail.invoiceType == 0 ? '普通发票' : '专用发票' }}</span>
          </a-form-item>
          <a-form-item label="发票抬头">
            <span>{{ detail.invoiceTitle }}</span>
          </a-form-item>
          <a-form-item label="申请时间">
            <span>{{moment(detail.createTime).format("YYYY-MM-DD HH:mm:ss")}}</span>
          </a-form-item>
          <a-form-item label="发票编号">
            <span>{{ detail.invoiceNo }}</span>
          </a-form-item>
        </a-form>
      </div>
      <div>
        <h3 class="subtitle">订单信息</h3>
        <a-table 
            :columns="detailColumns"
            :data-source="detail.orderList"
            bordered
            :pagination="false" 
            class="table-list"
        >
            <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
                <a-table :columns="orderColumns2" :data-source="record.orderDetails" :pagination="false" class="table-list">
                    <span slot="totalAmount" slot-scope="text">{{ text/100 }}</span>
                    <span slot="orderAmount" slot-scope="text">{{ text/100 }}</span>
                </a-table>
            </div>
            <span slot="orderAmount" slot-scope="text">{{ text/100 }}</span>
            <span slot="payTime" slot-scope="text">{{moment(text).format("YYYY-MM-DD HH:mm:ss")}}</span>
        </a-table>
      </div>
    </a-modal>

    <a-modal
      v-model="orderVisible"
      title="可开票订单"
      width="1000px"
      @ok="handleOk"
      @cancel="orderVisible = false"
      >
      <a-table
        :columns="orderColumns"
        :data-source="orderList" 
        bordered 
        :pagination="false"
        :row-selection="{ onChange: onSelectChange }"
        :rowKey="(record) => record.orderId"
        class="table-list">
        <template slot="payStatus" slot-scope="text">
            <a-tag v-if="text == 1" color="red">未付款</a-tag>
            <a-tag v-if="text == 2" color="green">已付款</a-tag>
        </template>
        <span slot="payAmount" slot-scope="text">{{ text/100 }}</span>
        <span slot="orderAmount" slot-scope="text">{{ text/100 }}</span>
        <span slot="createTime" slot-scope="text">{{ moment(text).format("YYYY-MM-DD HH:mm:ss") }}</span>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { queryApplyInvoiceSelfList, queryOrderList, applyInvoice } from '@/api/api'
import moment from 'moment'
const columns = [
  {
    title: '申请时间',
    dataIndex: 'createTime',
    key: 'createTime',
    align: 'center',
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: '开票方',
    dataIndex: 'drawer',
    key: 'drawer',
    align: 'center'
  },
  {
    title: '发票抬头',
    dataIndex: 'invoiceTitle',
    key: 'invoiceTitle',
    align: 'center'
  },
  {
    title: '发票总额(元)',
    dataIndex: 'invoiceAmount',
    key: 'invoiceAmount',
    align: 'center',
    scopedSlots: { customRender: "invoiceAmount" },
  },
  {
    title: '发票状态',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
]

const detailColumns = [
    {
        title: "订单号",
        dataIndex: "orderId",
        key: "orderId",
        align: "center",
    },
    {
        title: "订单支付时间",
        dataIndex: "payTime",
        key: "payTime",
        align: "center",
        scopedSlots: { customRender: 'payTime' },
    },
    {
        title: "金额(元)",
        dataIndex: "orderAmount",
        key: "orderAmount",
        align: "center",
        scopedSlots: { customRender: 'orderAmount' },
    },
];

const orderColumns = [
  {
    title: '订单编号',
    dataIndex: 'orderId',
    key: 'orderId',
    align: 'center'
  },
  {
    title: '订单金额(元)',
    dataIndex: 'orderAmount',
    key: 'orderAmount',
    align: 'center',
    scopedSlots: { customRender: 'orderAmount' },
  },
  {
    title: '实付金额(元)',
    dataIndex: 'payAmount',
    key: 'payAmount',
    align: 'center',
    scopedSlots: { customRender: 'payAmount' },
  },
  {
    title: '支付状态',
    dataIndex: 'payStatus',
    key: 'payStatus',
    align: 'center',
    scopedSlots: { customRender: 'payStatus' },
  },
  {
    title: '下单时间',
    dataIndex: 'createTime',
    key: 'createTime',
    align: 'center',
    scopedSlots: { customRender: 'createTime' },
  }
]

const statusList = [
  {
    color: 'red',
    text: '不可申请'
  },
  {
    color: 'blue',
    text: '可申请'
  },
  {
    color: 'orange',
    text: '申请中'
  },
  {
    color: 'green',
    text: '可下载'
  }
]

const orderColumns2 = [
  {
    title: '设备编号',
    dataIndex: 'deviceNo',
    key: 'deviceNo',
    align: 'center'
  },
  {
    title: '设备型号',
    dataIndex: 'deviceModel',
    key: 'deviceModel',
    align: 'center'
  },
  {
    title: '总金额(元)',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    align: 'center',
    scopedSlots: { customRender: 'totalAmount' },
  },
  {
    title: '订单优惠后金额(元)',
    dataIndex: 'orderAmount',
    key: 'orderAmount',
    align: 'center',
    scopedSlots: { customRender: 'orderAmount' },
  },
  {
    title: '优惠明细',
    dataIndex: 'reduceDetail',
    key: 'reduceDetail',
    align: 'center'
  },
]

const titleTypeList = ["个人", "企业", "事业单位"];

export default {
  data() {
    return {
        moment,
      searchForm: {
        orderId: '',
        invoiceStatus: undefined,
      },
      columns,
      list: [],
      visible: false,
      detail: {},

      detailColumns,

      orderVisible: false,
      orderList: [],

      statusList,
      orderColumns,
      orderColumns2,
      orderids: [],
      titleTypeList
    }
  },

  methods: {
    handleQuery() {
        this.getList()
    },

    resetForm() {
      this.$refs['searchForm'].resetFields()
      this.getList()
    },

    getList() {
        const para = {
            orderId: this.searchForm.orderId,
            invoiceStatus: this.searchForm.invoiceStatus
        }
        queryApplyInvoiceSelfList(para).then(({ error, response }) => {
            this.list = response.dataList
        })
    },

    handleInvoice() {
        this.orderVisible = true

        const para = {
            invoiceStatus: 1
        }
        queryOrderList(para).then(({response}) => {
            this.orderList = response.dataList
        })
    },

    // 查看详情
    handleDetail(row) {
      this.detail = Object.assign({}, row)

      this.detail.orderList.forEach(item => {
        item.orderDetails = item.orderDetails.map(vitem => {
            return {
                ...vitem,
                ...vitem.priceInfo
            }
        })
    });
      
      this.$nextTick(() => {
        this.visible = true
      })
    },

    onSelectChange(selectedRowKeys) {
        this.orderids = selectedRowKeys;
    },

    handleOk() {
        if (this.orderids.length == 0) {
            this.$message.error('请选择需要开票的订单')
            return
        }

        const para = {
            orderId: this.orderids
        }

        applyInvoice(para).then(({error, response}) => {
            if (error.code == 0) {
                this.orderVisible = false
                this.getList()
            }
        })
    },

    // 下载发票
    handleDownload(row) {
        // let url = 'http://192.168.0.60:2222/'+row.invoiceUrl

        let url = window.location.origin + row.invoiceUrl

        const elink = document.createElement('a')

        elink.href = url

        elink.setAttribute('target', '_blank')

        elink.style.display = 'none'

        document.body.appendChild(elink)

        setTimeout(() => {

            elink.click()

            document.body.removeChild(elink)

        }, 66)
    }
  },

  created() {
    this.getList()
  }
}
</script>

<style lang="less" scoped>
  /deep/ .info .ant-form-item {
    margin-bottom: 0;
  }
</style>